import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {RestFilterModel} from 'gelios-ng-admin-components';
import {ReflexiveField} from '../../lib/reflexive-model/reflexive-field';
import {ImmutableListRepositoryService} from '../../lib/gelios-field/immutable-list-repository.service';

export function clearFields(formGroup: FormGroup, fields: Array<string>, booleanFields: Array<string>) {
  if (!formGroup || !formGroup.controls) {
    return;
  }

  const controls = formGroup.controls;
  Object.entries(controls).forEach(([controlName, control]) => {
    if (fields.includes(controlName) || booleanFields.includes(controlName)) {
      let defaultValue = null;
      if (booleanFields.includes(controlName)) {
        defaultValue = false;
      }

      if (control instanceof FormControl) {
        control.setValue(defaultValue);
      } else if (control instanceof FormArray) {
        while (control.length !== 0) {
          control.removeAt(0);
        }
      }
      control.markAsUntouched();
    }
  });
}

export function formFieldIsEmpty(formGroup: FormGroup, fieldName: string): boolean {
  if (!formGroup || !formGroup.controls || !formGroup.controls[fieldName]) {
    return false;
  }

  const result = formGroup.controls[fieldName].value;
  return result === null || result === undefined;
}

export function setMultipleRestFilters(
  fields: {
    [fieldName: string]: ReflexiveField;
  },
  fieldName: string,
  filters: Array<{ filterName: string; filterType: 'number' | 'text', value: number | null }>,
  sourceType: 'foreignSource' | 'typeahead'
) {
  if (fields[fieldName] && fields[fieldName][sourceType]) {
    const filterFields: RestFilterModel = {
      ...fields[fieldName][sourceType].filterBehaviorSubject.getValue(),
    };
    filters.forEach((filter) => {
      if (filter.value !== null && filter.value !== undefined) {
        filterFields[filter.filterName] = createEqualsFilter(filter.filterType, filter.value);
      } else {
        delete filterFields[filter.filterName];
      }
    });
    const current = fields[fieldName][sourceType].filterBehaviorSubject.getValue();
    if (JSON.stringify(current) !== JSON.stringify(filterFields)) {
      fields[fieldName][sourceType].filterBehaviorSubject.next(filterFields);
    }
  }
}

export function setNumberRestFilter(
  fields: {
    [fieldName: string]: ReflexiveField;
  },
  fieldName: string,
  filterName: string,
  sourceType: 'foreignSource' | 'typeahead',
  value: number | null) {
  if (fields[fieldName] && fields[fieldName][sourceType]) {
    const filterFields: RestFilterModel = {
      ...fields[fieldName][sourceType].filterBehaviorSubject.getValue(),
    };
    if (value) {
      filterFields[filterName] = createEqualsFilter('number', value);
    } else {
      delete filterFields[filterName];
    }
    fields[fieldName][sourceType].filterBehaviorSubject.next(filterFields);
  }
}

export function setMultipleNumberRestFilters(
  fields: { [fieldName: string]: ReflexiveField },
  fieldName: string,
  sourceType: 'foreignSource' | 'typeahead',
  filters: { [filterName: string]: number | null }
) {
  if (fields[fieldName] && fields[fieldName][sourceType]) {
    const currentFilters: RestFilterModel = {
      ...fields[fieldName][sourceType].filterBehaviorSubject.getValue(),
    };

    Object.keys(filters).forEach((filterName) => {
      const value = filters[filterName];
      if (value !== null && value !== undefined) {
        currentFilters[filterName] = createEqualsFilter('number', value);
      } else {
        delete currentFilters[filterName];
      }
    });

    fields[fieldName][sourceType].filterBehaviorSubject.next(currentFilters);
  }
}

export function setTextRestFilter(
  fields: {
    [fieldName: string]: ReflexiveField;
  },
  fieldName: string,
  filterName: string,
  sourceType: 'foreignSource' | 'typeahead',
  value: string | null) {
  if (fields[fieldName] && fields[fieldName][sourceType]) {
    const filterFields: RestFilterModel = {
      ...fields[fieldName][sourceType].filterBehaviorSubject.getValue(),
    };
    if (value) {
      filterFields[filterName] = createEqualsFilter('text', value);
    } else {
      delete filterFields[filterName];
    }
    fields[fieldName][sourceType].filterBehaviorSubject.next(filterFields);
  }
}

export function createEqualsFilter(filterType: 'number' | 'text' | 'setof', value: unknown) {
  return {
    filterType: filterType,
    type: 'equals' as 'equals',
    filter: value,
    filterTo: null,
  };
}

export function getUnitTypeNameById(unit_type_id: number, immutableList: ImmutableListRepositoryService): string | null {
  const list = immutableList.getListInstant('unit-type');
  if (!list) {
    return null;
  }
  const row = list.find(r => r.id === unit_type_id) as { id: number, name: string, unit_type_name: string };
  return row ? row.unit_type_name : null;
}
